import React from 'react'
import { Button } from '../../../../UI'
import { HiOutlineMenuAlt2 } from 'react-icons/hi'
import Container from './styles'

const TopNav = ({ showNav, userData }) => {
  // Safely get user initials
  const getInitials = () => {
    if (!userData) return '??'
    const firstName = userData.first_name || userData.firstName || ''
    const lastName = userData.last_name || userData.lastName || ''
    return `${firstName[0] || '?'}${lastName[0] || '?'}`
  }

  // Safely get full name
  const getFullName = () => {
    if (!userData) return 'User'
    const firstName = userData.first_name || userData.firstName || ''
    const lastName = userData.last_name || userData.lastName || ''
    return `${firstName} ${lastName}`.trim() || 'User'
  }

  // Safely get company name
  const getCompanyName = () => {
    if (!userData) return 'Company User'
    return userData.companyName || userData.company_name || 'Company User'
  }

  return (
    <Container>
      <div className="welcome--detail">
        <Button icon className="toggleMenu--btn" onClick={showNav}>
          <HiOutlineMenuAlt2 />
        </Button>
        <h3>
          Welcome back,{' '}
          <span className="u--color__primary">
            {getFullName()}
          </span>
        </h3>
      </div>
      <div className="profile--btn" role="button">
        <div className="img--container">
          {getInitials()}
        </div>
        <div className="content--container">
          <p>
            {getFullName()}
          </p>
          <p>{getCompanyName()}</p>
        </div>
      </div>
    </Container>
  )
}

export default TopNav
